import * as Yup from 'yup';

import { phoneRegExp } from './Customer';

export const AddStaffSchema = Yup.object().shape({
  store: Yup.string().required('Studio is required'),
  username: Yup.string().required('Username is required'),
  firstName: Yup.string().nullable(true),
  lastName: Yup.string().nullable(true),
  email: Yup.string().email('Invalid email address').nullable(true),
  password1: Yup.string()
    .required('Password is required')
    .min(8, 'Password is too short - should be 8 chars minimum.'),
  password2: Yup.string().oneOf(
    [Yup.ref('password1'), null],
    'Passwords must match'
  )
});

export const UpdateStaffSchema = Yup.object().shape({
  username: Yup.string().nullable(true),
  firstName: Yup.string().nullable(true),
  lastName: Yup.string().nullable(true),
  email: Yup.string().email('Invalid email address').nullable(true)
});

export const UpdatePasswordByUserSchema = Yup.object().shape({
  password1: Yup.string()
    .required('Password is required')
    .min(8, 'Password is too short - should be 8 chars minimum.'),
  password2: Yup.string()
    .required('Confirm Password is required')
    .oneOf([Yup.ref('password1'), null], 'Passwords must match')
});

// funtion to return schema so reference datetime for startDate is init time, not last page load time
export const ExistingStaffEntrySchema = Yup.object().shape({
  roleId: Yup.number()
    .required('Role selection is required')
    .typeError('Role is required'),
  startDate: Yup.date()
    .required('Start Date is required')
    .typeError('Start Date is required')
});

// funtion to return schema so reference datetime for startDate is init time, not last page load time
export const NewStaffEntrySchema = Yup.object().shape({
  firstName: Yup.string()
    .required('First Name is required')
    .typeError('First Name is required'),
  lastName: Yup.string()
    .required('Last Name is required')
    .typeError('Last Name is required'),
  email: Yup.string()
    .email('Invalid email address')
    .required('Email is required')
    .typeError('Email is required'),
  phone: Yup.string()
    .matches(phoneRegExp, 'Phone number is not valid')
    .required('Phone number is required')
    .min(10)
    .max(10)
    .typeError('Phone number is required'),
  roleId: Yup.number()
    .required('Role selection is required')
    .typeError('Role is required'),
  startDate: Yup.date()
    .required('Start Date is required')
    .typeError('Start Date is required')
});

export const RemoveStaffSchema = Yup.object().shape({
  endDate: Yup.date().required('End Date is required')
});

export const EditStaffSchema = Yup.object().shape({
  firstName: Yup.string()
    .required('First Name is required')
    .typeError('First Name is required'),
  lastName: Yup.string()
    .required('Last Name is required')
    .typeError('Last Name is required'),
  email: Yup.string()
    .email('Invalid email address')
    .required('Email is required')
    .typeError('Email is required'),
  phone: Yup.string()
    .matches(phoneRegExp, 'Phone number is not valid')
    .nullable()
    .optional()
    .min(10)
    .max(10)
    .typeError('Phone number is required'),
  roleId: Yup.number()
    .required('Role selection is required')
    .typeError('Role is required'),
  startDate: Yup.date().required('Start Date is required').nullable().optional()
});
